import React from 'react'

const NotFound = () => {
  return (
    <div>
      <h1>NotFound Component</h1>
    </div>
  )
}

export default NotFound
